import styles from './HeaderTitleContent.module.scss'
import ReturnBackBtn from '../ReturnBackBtn/ReturnBackBtn'

export interface HeaderTitleContentProps {
    children?: React.ReactNode
    onGoBack?: () => void
    goBackBtnName?: string
    withGoBackBtn?: boolean
    goBackBtnLabel?: string
    goBackTo?: string
}
export default function HeaderTitleContent({children, withGoBackBtn, goBackBtnLabel, goBackTo, onGoBack}: HeaderTitleContentProps) {


  return (
    <div className={styles['header']}>
      <div className={styles['header__back-btn']}>
        {
            withGoBackBtn && (

              <ReturnBackBtn  label={goBackBtnLabel} linnkTo={goBackTo} onClick={onGoBack} size='small'/>
            )
        }
      </div>

        <h1 className={styles['header__title']}>{children}</h1>
    </div>
  )
}
